import { render, staticRenderFns } from "./MerchantAdminInfo.vue?vue&type=template&id=ad072ecc&scoped=true&"
import script from "./MerchantAdminInfo.vue?vue&type=script&lang=js&"
export * from "./MerchantAdminInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad072ecc",
  null
  
)

export default component.exports